<div id="cm-landing-page-styles">
    <!-- UPS Truck Spinner -->
    <ngx-spinner name="upsSpinner" bdColor="rgba(255, 255, 255, 0.8)" size="medium" color="#321815" type="custom" [fullScreen]="true">
        <app-spinner></app-spinner>
    </ngx-spinner>

    <div class="container pt-5" id="landingSize">
        <div class="landing-row">
            <div class="row landing-cards">
                <mat-card class="example-card" role="button" tabindex="0" (click)="navigateModule('admin-functions')" (keydown.enter)="navigateModule('admin-functions')" (keydown.space)="navigateModule('admin-functions')" [ngClass]="{'disabled-card': !adminPermissions}">
                    <mat-card-content>
                        <p class="card-icon">
                            <mat-icon class="card-icon-color">manage_accounts</mat-icon>
                        </p>
                        <p class="card-text">Admin Functions</p>
                    </mat-card-content>
                </mat-card>

                <mat-card class="example-card" role="button" tabindex="0" (click)="navigateModule('new-view-requests')" (keydown.enter)="navigateModule('new-view-requests')" (keydown.space)="navigateModule('new-view-requests')" [ngClass]="{'disabled-card': !RaiseRequestPermissions}">
                    <mat-card-content>
                        <p class="card-icon">
                            <mat-icon class="card-icon-color">create</mat-icon>
                        </p>
                        <p class="card-text">New/View Requests</p>
                    </mat-card-content>
                </mat-card>

                <mat-card class="example-card" role="button" tabindex="0" (click)="navigateModule('approval-dashboard')" (keydown.enter)="navigateModule('approval-dashboard')" (keydown.space)="navigateModule('approval-dashboard')" [ngClass]="{'disabled-card': !ApprovalDashboardPermissions}">
                    <mat-card-content>
                        <p class="card-icon">
                            <mat-icon class="card-icon-color">done_all</mat-icon>
                        </p>
                        <p class="card-text">Approval DashBoard</p>
                    </mat-card-content>
                </mat-card>

                <mat-card class="example-card" role="button" tabindex="0" (click)="navigateModule('requestStatusReport')" (keydown.enter)="navigateModule('requestStatusReport')" (keydown.space)="navigateModule('requestStatusReport')">
                    <mat-card-content>
                        <p class="card-icon">
                            <mat-icon class="card-icon-color">watch_later</mat-icon>
                        </p>
                        <p class="card-text">Request Status/Reports</p>
                    </mat-card-content>
                </mat-card>
            </div>

            <div class="row landing-cards">
                <mat-card class="example-card" role="button" tabindex="0" (click)="navigateModule('bulk-request')" (keydown.enter)="navigateModule('bulk-request')" (keydown.space)="navigateModule('bulk-request')" [ngClass]="{'disabled-card': !BulkRequestPermissions}">
                    <mat-card-content>
                        <p class="card-icon">
                            <mat-icon class="card-icon-color">group_add</mat-icon>
                        </p>
                        <p class="card-text">Bulk Request</p>
                    </mat-card-content>
                </mat-card>

                <mat-card class="example-card" role="button" tabindex="0" (click)="navigateModule('gbs-dashboard')" (keydown.enter)="navigateModule('gbs-dashboard')" (keydown.space)="navigateModule('gbs-dashboard')" [ngClass]="{'disabled-card': !GBSBillingPermissions}">
                    <mat-card-content>
                        <p class="card-icon">
                            <mat-icon class="card-icon-color">check_circle</mat-icon>
                        </p>
                        <p class="card-text">GBS Billing</p>
                    </mat-card-content>
                </mat-card>
            </div>

            <div class="mobile-svg">
                <div id="dashboard" class="landing-link" [class.disabled]="!RaiseRequestPermissions" [routerLink]="['/request']">New Request</div>
                <div id="dashboard" class="landing-link" [class.disabled]="!ApprovalDashboardPermissions" [routerLink]="['/approval-dashboard']">Approval Dashboard</div>
                <div id="request-status" class="landing-link" [class.disabled]="!GBSBillingPermissions" routerLink="/request-status-reports">Request Status & Reports</div>
                <div id="dashboard" class="landing-link" [class.disabled]="!adminPermissions" [routerLink]="['/admin-request']">Admin</div>
                <div id="gbs" class="landing-link" [class.disabled]="!GBSBillingPermissions" [routerLink]="['/gbs-dashboard']">GBS Billing</div>
            </div>
        </div>
    </div>
</div>

<div class="footer">
    <app-site-footer></app-site-footer>
</div>
